import OaApiService from './OaApiService';

export default class OutboundCommsService extends OaApiService {
  sendReviewRequest(data, leadKey) {
    return this.post('/OutboundCommsREST/send-review-request-to-vendor', data, leadKey);
  }
}
